export const COMMON_SET_AGREEMENT_LINK = "COMMON_SET_AGREEMENT_LINK";
export const COMMON_RESET = "COMMON_RESET";
